import React, { useState } from 'react';
import '../css/AddTripPopup.css';
import { tripAPI } from '../api/apiClient';
import { useNavigate } from 'react-router-dom';
import useApi from './CustomHooks/useApi';
import { useToast } from '../Contexts/ToastContext';

const AddTripPopup = ({ show, onClose }) => {
  const [tripName, setTripName] = useState('');
  const navigate = useNavigate();
  const {showToast, clearToast} = useToast();

  const { isLoading, callApi } = useApi();

  const handleSave = async () => {
    if (!tripName.trim()) {
      showToast('Nazwa wycieczki nie może być pusta.', 'error');
      return;
    }
    showToast('Tworzenie nowej wycieczki...', 'processing');

  await callApi(async () => await tripAPI.createNewTrip(tripName),
    async (response) => {
      await navigate(`trips/${response}`)
      showToast('Nowa wycieczka utworzona pomyślnie!', 'success')
      }, clearToast
    );
  };

  const handleClose = () => {
    setTripName('');
    onClose();
  };

  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Dodaj nową wycieczkę</h2>
        <input
          type="text"
          placeholder="Podaj nazwę wycieczki"
          value={tripName}
          onChange={(e) => setTripName(e.target.value)}
          disabled={isLoading}
        />
       <div className="popup-button-group">
        <button
          className="popup-cancel-button"
          onClick={handleClose}
          disabled={isLoading}
        >
          Anuluj
        </button>
        <button
          className="popup-save-button"
          onClick={handleSave}
          disabled={isLoading}
        >
          {isLoading ? 'Zapisywanie...' : 'Zapisz'}
        </button>
      </div>
      </div>
    </div>
  );
};

export default AddTripPopup;
